import React, { useState, useEffect } from 'react';
import BoxWrapper from '../../../../components/ui/boxWrapper';
import axios from "../../../../axios-order";
import { Dialog, DialogActions, DialogContent, DialogTitle, TextField, MenuItem, Select, FormControl, InputLabel, Grid, FormHelperText, Checkbox } from '@mui/material';
import { Snackbar, Alert } from '@mui/material';
import Appbar from '../../../../components/appBar/appBar';

function WhiteLabel() {
  const [mappingData, setMappingData] = useState(null);
  const [openDialog, setOpenDialog] = useState(false);
  const [zohoTdsName, setZohoTdsName] = useState('');
  const [cwsTdsName, setCwsTdsName] = useState('');
  const [zohoTdsNameError, setZohoTdsNameError] = useState('');
  const [cwsTdsNameError, setCwsTdsNameError] = useState('');
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState('success');
  const [selectedIds, setSelectedIds] = useState([]);
  const [preSelectedIds, setPreSelectedIds] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');

  const getMappingData = () => {
    axios.get("/get_entity_list_to_whitelabel")
      .then((res) => {
        const records = res.data.records;
        setMappingData(records);

        const preSelected = records
          .filter((item) => item.is_white_labeled === true)
          .map((item) => item.business_entity_id);

        setPreSelectedIds(preSelected); // store separately
        setSelectedIds(preSelected);    // still show them as checked in UI
      })
      .catch((err) => console.log(err));
  };

  const handleCheckbox = (id) => {
    setSelectedIds((prev) =>
      prev.includes(id) ? prev.filter((item) => item !== id) : [...prev, id]
    );
  };

  useEffect(() => {
    getMappingData();
  }, []);

  const filteredData = (mappingData || []).filter((item) => {
    const q = searchQuery.toLowerCase();
    return (
      item.entity_name?.toLowerCase().includes(q) ||
      item.gst?.toLowerCase().includes(q)
    );
  });

  const tableBodyData = () => {
    if (filteredData.length > 0) {
      return filteredData.map((item, i) => (
        <tr key={i}>
          <td>{item.entity_name}</td>
          <td>{item.gst}</td>
          <td>
            <Checkbox
              checked={selectedIds.includes(item.business_entity_id)}
              onChange={() => handleCheckbox(item.business_entity_id)}
              color="primary"
            />
          </td>
        </tr>
      ));
    } else {
      return (
        <tr>
          <td style={{ textAlign: "center", color: "red" }} colSpan={3}>
            No Data Found!
          </td>
        </tr>
      );
    }
  };

  const handleClear = () => {
    setZohoTdsName('');
    setCwsTdsName('');
    setZohoTdsNameError('');
    setCwsTdsNameError('');
  };

  const handleDialogClose = () => {
    handleClear();
    setOpenDialog(false);
  };

  const handleCloseSnackbar = () => {
    setOpenSnackbar(false);
  };

  const handleSubmit = () => {
  // Newly checked: was false, now true
    const newlyChecked = mappingData
      .filter((item) =>
        selectedIds.includes(item.business_entity_id) &&
        !preSelectedIds.includes(item.business_entity_id)
      )
      .map((item) => ({ ...item, is_white_labeled: true }));

  // Newly unchecked: was true, now false
    const newlyUnchecked = mappingData
      .filter((item) =>
        !selectedIds.includes(item.business_entity_id) &&
        preSelectedIds.includes(item.business_entity_id)
      )
      .map((item) => ({ ...item, is_white_labeled: false }));

    const combinedRecords = [...newlyChecked, ...newlyUnchecked];

    if (combinedRecords.length === 0) {
      setSnackbarMessage('No changes to update.');
      setSnackbarSeverity('info');
      setOpenSnackbar(true);
      return;
    }

    const payload = { records: combinedRecords };

    axios
      .post("/update_white_label_status", payload)
      .then((response) => {
        setSnackbarMessage(response.data.message);
        setSnackbarSeverity('success');
        setOpenSnackbar(true);
      getMappingData(); // refresh pre-selected state after save
      })
      .catch((error) => {
        console.error("Error:", error);
        setSnackbarMessage('Something went wrong!');
        setSnackbarSeverity('error');
        setOpenSnackbar(true);
      });
  };

  return (
    <>
      <Appbar />
      <div style={{ margin: "30px", marginTop: "80px" }}>
        <BoxWrapper
          boxTitle="White Label"
          enableAddButton={true}
          addButtonLabel="SUBMIT"
          addButtonHandlerFn={handleSubmit}
          // ── Search field placed to the left of the Submit button ──
          enableSearchInput={true}
          searchInputPlaceholder="Search"
          searchInputValue={searchQuery}
          searchInputOnchange={(e) => setSearchQuery(e.target.value)}
        //  enableSearchInput={this.state.loading === false ? true : ""}
        //             searchInputPlaceholder="Search..."
        //             searchInputOnchange={this.handleSearchInputChange}

        >
          <div className="responsive-table-tds-threshold">
            <table className="custome-table">
              <tbody>
                <tr>
                  <th>Entity Name</th>
                  <th>GSTIN</th>
                  <th>Label</th>
                </tr>
                {tableBodyData()}
              </tbody>
            </table>
          </div>
        </BoxWrapper>
      </div>

      <Dialog
        open={openDialog}
        onClose={handleDialogClose}
        sx={{
          '& .MuiDialog-paper': {
            width: '50%',
            maxWidth: 'none',
          },
        }}
      >
        <DialogTitle sx={{ padding: '8px 16px' }}>Add Zoho TDS Mapping</DialogTitle>
        <DialogContent sx={{ padding: '8px 16px', minHeight: '100px' }}>
          <Grid container spacing={2}>
            <Grid item lg={6} sx={{ marginBottom: '16px' }}>
              <TextField
                label="TAX Name"
                value={zohoTdsName}
                onChange={(e) => setZohoTdsName(e.target.value)}
                fullWidth
                margin="normal"
                helperText={zohoTdsNameError}
                FormHelperTextProps={{ sx: { color: 'red' } }}
              />
            </Grid>
            <Grid item lg={6}>
              <TextField
                label="CWS Section Name"
                value={cwsTdsName}
                onChange={(e) => setCwsTdsName(e.target.value)}
                fullWidth
                margin="normal"
                helperText={cwsTdsNameError}
                FormHelperTextProps={{ sx: { color: 'red' } }}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions sx={{ padding: '8px 16px' }}>
          <div className="mt-20">
            <button className="button-primary" onClick={handleSubmit} type="submit">
              Submit
            </button>
            <button
              type="button"
              className="button-outlined-secondary"
              onClick={handleDialogClose}
            >
              Cancel
            </button>
          </div>
        </DialogActions>
      </Dialog>

      <Snackbar
        open={openSnackbar}
        autoHideDuration={6000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert onClose={handleCloseSnackbar} severity={snackbarSeverity} sx={{ width: '100%' }}>
          {snackbarMessage}
        </Alert>
      </Snackbar>

    </>
  );
}

export default WhiteLabel;